/*
 * Title: Rewards/MobileHead.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Lifetime Points head toggle, click on points box to box will expanded.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:1.0.0
 */

import React from "react";
import KnightsCard from "./KnightsCard";

type Props = {};
type MyState = {};
class MobileHead extends React.Component<Props, MyState> {
  state: MyState = {};

  render() {
    return (
      <div className="lg:hidden">
        <KnightsCard />
      </div>
    );
  }
}

export default MobileHead;
